module.exports = "../content/301fe70f8f0f41c236317504ec05f820.ttf";